<div class="breadcrumb-area">
	<h1>Reportes de Gastos</h1>
</div>

<div class="card mb-3" id="integratedCategoryReport">
	<div class="title-report card-header d-flex justify-content-between align-items-center"
		(click)="showReport(1)">
		<h3>Integración por Categorías y Reportería</h3>
		<h3><i [ngClass]="selectedReport==1?'fa-minus':'fa-plus'" class="fa"></i></h3>
	</div>
	<div class="card-body" *ngIf="selectedReport==1">
		<div class="row">
			<div class="col-sm">
				<div class="form-group">
					<label for="startDate6" class="form-label">Fecha Inicial:</label>
					<input type="date" [(ngModel)]="startDate" id="startDate6" name="startDate6" class="form-control">
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="endDate6" class="form-label">Fecha Final:</label>
					<input type="date" [(ngModel)]="endDate" id="endDate6" name="endDate6" class="form-control">
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="account-input" class="form-label">Cuenta: </label>
					<div class="input-group input-group-sm">
						<app-input-autocomplete [allBorderRadius]="true" [inputs]="inputs.account"
							[placeholder]="'Código o nombre de la cuenta'" [filterElements]="filterAccounts"
							[typeElements]="'account'"
							(inputMethod)="writeAccount($event.event)"
							(getTitle)="$event.filterElement.title = $event.filterElement.displayId+' - '+$event.filterElement.name"
							(changeStatus)="selectAccount($event.filterElement)"></app-input-autocomplete>
					</div>
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="filterSpendingReport1" class="form-label">Búsqueda</label>
					<input type="text" id="filterSpendingReport1" placeholder="Buscar en gastos"
						name="filterSpendingReport1" class="form-control">
				</div>
			</div>
			<div class="col-sm download-buttons">
				<button class="btn btn-success" (click)="getSpendingReport('excel')" data-bs-toggle="tooltip" title="Descargar Excel"><i
						class="fa fa-file-excel"></i></button>
				<button class="btn btn-primary" (click)="getSpendingReport('pdf')" data-bs-toggle="tooltip" title="Descargar PDF"><i
						class="fa fa-file-pdf"></i></button>
				<button class="btn btn-secondary" data-bs-toggle="tooltip" title="Ver Reporte"><i
						class="fa fa-eye"></i></button>
			</div>
		</div>
	</div>
</div>

<div class="card mb-3" id="integratedExpenseReport">
	<div class="title-report card-header d-flex justify-content-between align-items-center"
		(click)="showReport(2)">
		<h3>Integración por Gastos y Reportería</h3>
		<h3><i [ngClass]="selectedReport==2?'fa-minus':'fa-plus'" class="fa"></i></h3>
	</div>
	<div class="card-body" *ngIf="selectedReport==2">
		<div class="row">
			<div class="col-sm">
				<div class="form-group">
					<label for="firstMonth2" class="form-label">Primer mes:</label>
					<select name="firstMonth2" id="firstMonth2" [(ngModel)]="firstMonth2" class="form-select">
						<option value="0">Enero</option>
						<option value="1">Febrero</option>
						<option value="2">Marzo</option>
						<option value="3">Abril</option>
						<option value="4">Mayo</option>
						<option value="5">Junio</option>
						<option value="6">Julio</option>
						<option value="7">Agosto</option>
						<option value="8">Septiembre</option>
						<option value="9">Octubre</option>
						<option value="10">Noviembre</option>
						<option value="11">Diciembre</option>
					</select>
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="year" class="form-label">Seleccionar año:</label>
					<select name="year2" id="year2" [(ngModel)]="year2" class="form-select">
						<option *ngFor="let y of years" value="{{y}}">{{y}}</option>
					</select>
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="secondMonth2" class="form-label">Segundo mes:</label>
					<select name="secondMonth2" id="secondMonth2" [(ngModel)]="secondMonth2" class="form-select">
						<option value="0">Enero</option>
						<option value="1">Febrero</option>
						<option value="2">Marzo</option>
						<option value="3">Abril</option>
						<option value="4">Mayo</option>
						<option value="5">Junio</option>
						<option value="6">Julio</option>
						<option value="7">Agosto</option>
						<option value="8">Septiembre</option>
						<option value="9">Octubre</option>
						<option value="10">Noviembre</option>
						<option value="11">Diciembre</option></select>
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="account-input" class="form-label">Cuenta: </label>
					<div class="input-group input-group-sm">
						<app-input-autocomplete [allBorderRadius]="true" [inputs]="inputs.account"
							[placeholder]="'Código o nombre de la cuenta'" [filterElements]="filterAccountsExpenses"
							[typeElements]="'account'"
							(inputMethod)="writeAccountExpense($event.event)"
							(getTitle)="$event.filterElement.title = $event.filterElement.displayId+' - '+$event.filterElement.name"
							(changeStatus)="selectAccount($event.filterElement)"></app-input-autocomplete>
					</div>
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="filterSpendingReport2" class="form-label">Búsqueda</label>
					<input type="text" id="filterSpendingReport2" placeholder="Buscar en gastos"
						name="filterSpendingReport2" class="form-control">
				</div>
			</div>
			<div class="col-sm download-buttons">
				<button class="btn btn-success" (click)="getSpendingReport2('excel')" data-bs-toggle="tooltip" title="Descargar Excel"><i
						class="fa fa-file-excel"></i></button>
				<button class="btn btn-primary" (click)="getSpendingReport2('pdf')" data-bs-toggle="tooltip" title="Descargar PDF"><i
						class="fa fa-file-pdf"></i></button>
				<button class="btn btn-secondary" data-bs-toggle="tooltip" title="Ver Reporte"><i
						class="fa fa-eye"></i></button>
			</div>
		</div>
	</div>
</div>

<div class="card mb-3" id="report3">
	<div class="title-report card-header d-flex justify-content-between align-items-center"
		(click)="showReport(3)">
		<h3>Control de Gastos y Reportería</h3>
		<h3><i [ngClass]="selectedReport==3?'fa-minus':'fa-plus'" class="fa"></i></h3>
	</div>
	<div class="card-body" *ngIf="selectedReport==3">
		<div class="row">
			<div class="col-sm">
				<div class="form-group">
					<label for="firstMonth3" class="form-label">Primer mes:</label>
					<select name="firstMonth3" id="firstMonth3" [(ngModel)]="firstMonth" class="form-select">
						<option value="0">Enero</option>
						<option value="1">Febrero</option>
						<option value="2">Marzo</option>
						<option value="3">Abril</option>
						<option value="4">Mayo</option>
						<option value="5">Junio</option>
						<option value="6">Julio</option>
						<option value="7">Agosto</option>
						<option value="8">Septiembre</option>
						<option value="9">Octubre</option>
						<option value="10">Noviembre</option>
						<option value="11">Diciembre</option>
					</select>
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="year3" class="form-label">Seleccionar año:</label>
					<select name="year3" id="year3" [(ngModel)]="year" class="form-select">
						<option *ngFor="let y of years" value="{{y}}">{{y}}</option>
					</select>
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="secondMonth3" class="form-label">Segundo mes:</label>
					<select name="secondMonth3" id="secondMonth3" [(ngModel)]="secondMonth" class="form-select">
						<option value="0">Enero</option>
						<option value="1">Febrero</option>
						<option value="2">Marzo</option>
						<option value="3">Abril</option>
						<option value="4">Mayo</option>
						<option value="5">Junio</option>
						<option value="6">Julio</option>
						<option value="7">Agosto</option>
						<option value="8">Septiembre</option>
						<option value="9">Octubre</option>
						<option value="10">Noviembre</option>
						<option value="11">Diciembre</option></select>
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="account-input" class="form-label">Cuenta: </label>
					<div class="input-group input-group-sm">
						<app-input-autocomplete [allBorderRadius]="true" [inputs]="inputs.account"
							[placeholder]="'Código o nombre de la cuenta'" [filterElements]="filterAccounts"
							[typeElements]="'account'"
							(inputMethod)="writeAccount($event.event)"
							(getTitle)="$event.filterElement.title = $event.filterElement.displayId+' - '+$event.filterElement.name"
							(changeStatus)="selectAccount($event.filterElement)"></app-input-autocomplete>
					</div>
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="filterSpendingReport2" class="form-label">Búsqueda</label>
					<input type="text" id="filterSpendingReport2" placeholder="Buscar en gastos"
						name="filterSpendingReport2" class="form-control">
				</div>
			</div>
			<div class="col-sm download-buttons">
				<button class="btn btn-success" (click)="getSpendingReport3('excel')" data-bs-toggle="tooltip" title="Descargar Excel"><i
						class="fa fa-file-excel"></i></button>
				<button class="btn btn-primary" (click)="getSpendingReport3('pdf')" data-bs-toggle="tooltip" title="Descargar PDF"><i
						class="fa fa-file-pdf"></i></button>
				<button class="btn btn-secondary" data-bs-toggle="tooltip" title="Ver Reporte"><i
						class="fa fa-eye"></i></button>
			</div>
		</div>
	</div>
</div>